import React from 'react';

import clientInfoTabs from '../../components/ClientInfo/tabs';
import { ClientStatus } from '../../utils/statusFilter';
import { ALL_CLIENTS } from '../../pages/ManageClients/utils';

const initialValues = {
  clientList: [],
  clientDataList: [],
  isReady: false,
  clientSortModel: [
    {
      field: 'name',
      sort: 'asc',
    },
  ],
  setClientSortModel: () => { },
  selectedTab: clientInfoTabs.CHECKIN_ACTIVITY,
  setSelectedTab: () => { },
  clientFilters: [ClientStatus.ACTIVE],
  setClientFilters: () => { },
  clientExcludingFilters: [],
  setClientExcludingFilters: () => {},
  clientTagsDocs: [],
  clientTagsFilters: [],
  setClientTagsFilters: () => {},
  baseClientTagsCollection: { docs: [] },
  customClientTagsCollection: { docs: [] },
  allUsersLoaded: false,
  loadingUsers: false,
  setClientPaginationModel: () => {},
  selectedUserType: ALL_CLIENTS,
};

const ManageClientContext = React.createContext(initialValues);

export default ManageClientContext;
export {
  initialValues,
};
